import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "Delight your customers by using WhatsApp automations for top-notch support",
    listHeading:
        "Discover how forward-thinking businesses are solving their biggest support challenges through WhatsApp—the messaging platform your customers already love and trust.",
    listText: [
        { label: "Eliminate slow response times and deliver instant support that keeps customers coming back" },
        { label: "Reduce team burnout while handling multiple conversations through smart automation" },
        { label: "Create a seamless support experience that dramatically improves customer satisfaction and retention" },
    ],

    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/support.png",
    altMedia: "gallabox-e-book",
    ebookName: "support",
};

const EBookWhyWhatsappForSupport: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Automation Tool For Service Companies - Gallabox eBooks"
            description="WhatsApp automation is helping the best service companies drive more quality service bookings, while reducing burnout and increasing revenue. Download the eBook now"
            canonical="https://gallabox.com/resources/whatsapp-for-support-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/support-og.png" }}
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">Trusted by over 2,000 companies across 40+ countries</h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForSupport;
